/**
 * TransactionProtection - Security features section
 */
import { Shield, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TransactionProtection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-amber-50 to-yellow-50 dark:from-amber-950/20 dark:to-yellow-950/20">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
          {/* Text Content */}
          <div className="text-center md:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 text-amber-700 dark:text-amber-400 text-sm font-medium mb-4">
              <Shield className="w-4 h-4" />
              {t('home.protection.badge')}
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold mb-3">
              {t('home.protection.title')}
            </h2>
            <p className="text-muted-foreground max-w-md">
              {t('home.protection.desc')}
            </p>
            <div className="mt-6 flex flex-wrap gap-4 justify-center md:justify-start">
              <span className="inline-flex items-center gap-2 text-sm text-amber-700 dark:text-amber-400">
                <Check className="w-4 h-4" /> {t('home.protection.f1')}
              </span>
              <span className="inline-flex items-center gap-2 text-sm text-amber-700 dark:text-amber-400">
                <Check className="w-4 h-4" /> {t('home.protection.f2')}
              </span>
              <span className="inline-flex items-center gap-2 text-sm text-amber-700 dark:text-amber-400">
                <Check className="w-4 h-4" /> {t('home.protection.f3')}
              </span>
            </div>
          </div>
          
          {/* Security Vault Image */}
          <div className="flex-shrink-0">
            <img
              src="https://customer-assets.emergentagent.com/job_global-exchange-28/artifacts/mrdeb1zj_bank-grage-security-3.png"
              alt="Secure Transaction Protection"
              className="w-32 h-32 md:w-40 md:h-40 object-contain drop-shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransactionProtection;
